import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=e20e194c&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e20e194c')) {
      api.createRecord('e20e194c', component.options)
    } else {
      api.reload('e20e194c', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=e20e194c&", function () {
      api.rerender('e20e194c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OFwh7Xm6uPYD/JS/videoIframe.vue"
export default component.exports